// 直接导入各个模块
import authModule from "./auth/index.js";
import brokerModule from "./broker/index.js";
import clientModule from "./client/index.js";
import ibModule from "./ib/index.js";
import menuModule from "./menu/index.js";
import operationModule from "./operation/index.js";
import publicModule from "./public/index.js";
import reportModule from "./report/index.js";
import settingModule from "./setting/index.js";
import superModule from "./super/index.js";
import tradingModule from "./trading/index.js";
import userModule from "./user/index.js";
const modules = [];

// 模块配置
const moduleConfigs = [
  { name: "auth", data: authModule },
  { name: "client", data: clientModule },
  { name: "report", data: reportModule },
  { name: "setting", data: settingModule },
  { name: "public", data: publicModule },
  { name: "user", data: userModule },
  { name: "trading", data: tradingModule },
  { name: "broker", data: brokerModule },
  { name: "ib", data: ibModule },
  { name: "menu", data: menuModule },
  { name: "super", data: superModule },
  { name: "operation", data: operationModule },
];

// 处理每个模块
moduleConfigs.forEach(({ name, data }) => {
  if (Array.isArray(data)) {
    const processedItems = data.map((item) => ({
      ...item,
      url: `/v1/${name}${item.url}`,
    }));
    modules.push(...processedItems);
  } else {
  }
});

export default modules;
